import { queryContractType } from "@api/xxcrm/contract";
import localDb from "@util/localDb";

// 按模块的action, reducer整合体
const CONTRACT_TYPE = 'CONTRACT_TYPE';

export function getContractType() {
  return dispatch => {
    return queryContractType().then(res => {
      if (res.statusCode === 200) {
        localDb.set(CONTRACT_TYPE, res.data);
        return dispatch({
          type: CONTRACT_TYPE,
          data: res.data,
        });
      }
    });
  };
}

// Reducer
export function contractType(state = {}, action) {
  switch (action.type) {
    case CONTRACT_TYPE:
      return action.data;
    default:
      return localDb.get(CONTRACT_TYPE);
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/contract_type.js